
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.309 21.745"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"svg",attrs:{"d":"M4.53.906A.906.906 0 015.436 0h5.436a.906.906 0 010 1.812H5.436A.906.906 0 014.53.906zm11.56 17.666l-3.39-7.118a15.231 15.231 0 01-1.827-6.349V3.624H9.06v1.812a17.562 17.562 0 002 6.8l3.391 7.116a.4.4 0 01-.341.583h-1.353l-3.966-8.154H5.455a16.779 16.779 0 001.788-6.342l.005-1.812H5.436v1.479a15.227 15.227 0 01-1.826 6.347L.218 18.571A2.23 2.23 0 000 19.53a2.208 2.208 0 002.2 2.215h11.913a2.214 2.214 0 001.977-3.173z"}})])
          )
        }
      }
    